export const DESKTOP_HISTORY_LIMIT = 20
export const MOBILE_HISTORY_LIMIT = 10
